export const env = 'prod';
export const baseUrl = 'https://pay.api.surepoint.cloud/';
export const pageTitle = 'SurePoint Pay';
